var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("h1", [_vm._v("Dashboard")]),
    _vm._v(" "),
    _vm.is_loaded
      ? _c("div", [
          _vm.hasRole("admin") ||
          _vm.hasRole("editor") ||
          _vm.hasRole("sales") ||
          _vm.hasRole("tester") ||
          _vm.hasRole("callcenter")
            ? _c("div")
            : _vm.is_premium
            ? _c("div", [
                _c("div", { staticClass: "container-fluid p-0" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-12 col-sm-6" }, [
                      _c("div", { staticClass: "card" }, [
                        _c("div", { staticClass: "card-body px-3 pt-4" }, [
                          _c("h4", { staticClass: "card-title" }, [
                            _vm._v("Investor World Map"),
                          ]),
                          _vm._v(" "),
                          _c("iframe", {
                            staticStyle: {
                              border: "0",
                              width: "100%",
                              height: "440px",
                              background: "transparent",
                            },
                            attrs: { id: "map_url_frame", src: _vm.map_url },
                          }),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12 col-sm-6" }, [
                      _c("div", { staticClass: "card" }, [
                        _c("div", { staticClass: "card-body px-3 pt-4" }, [
                          _c("h4", { staticClass: "card-title" }, [
                            _vm._v("Investor Treemap"),
                          ]),
                          _vm._v(" "),
                          _c("iframe", {
                            staticStyle: {
                              border: "0",
                              width: "100%",
                              height: "440px",
                              background: "transparent",
                            },
                            attrs: {
                              id: "treemap_url_frame",
                              src: _vm.treemap_url,
                            },
                          }),
                        ]),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row pta-pipeline-status-home" }, [
                    _c("div", { staticClass: "col-12 col-sm-3" }, [
                      _c("div", { staticClass: "card" }, [
                        _c("div", { staticClass: "card-body px-3 pt-4" }, [
                          _c("span", [_vm._v(_vm._s(_vm.investors_number))]),
                          _vm._v("Active Deals"),
                          _c("br"),
                          _vm._v(" \n\n              "),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12 col-sm-6" }, [
                      _c("div", { staticClass: "card" }, [
                        _c("div", { staticClass: "card-body px-3 pt-4" }, [
                          _c("span", [
                            _vm._v(
                              "$" +
                                _vm._s(
                                  _vm._f("formatAmount")(_vm.investors_amount)
                                )
                            ),
                          ]),
                          _vm._v("Average Deal Value"),
                          _c("br"),
                          _vm._v(" \n              "),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12 col-sm-3" }, [
                      _c("div", { staticClass: "card" }, [
                        _c("div", { staticClass: "card-body px-3 pt-4" }, [
                          _c("span", [_vm._v(_vm._s(_vm.investors_completed))]),
                          _vm._v("Number of "),
                          _c("br"),
                          _vm._v("meetings completed\n\n            "),
                        ]),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm._m(0),
                ]),
              ])
            : _c("div", [
                _c("p", [
                  _vm._v(
                    "Keep an eye on the metrics that matter for your performance."
                  ),
                ]),
                _vm._v(" "),
                _c("img", {
                  staticStyle: {
                    width: "100%",
                    "max-width": "1280px",
                    display: "block",
                  },
                  attrs: { src: "/images/dashboard_preview.png" },
                }),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "pta-button",
                    attrs: { href: "/account/calendar" },
                  },
                  [_vm._v("PROCEED TO BOOK A CALL WITH US")]
                ),
              ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12 col-sm-12" }, [
        _c(
          "a",
          { staticClass: "pta-button", attrs: { href: "/account/calendar" } },
          [_vm._v("PROCEED TO BOOK A CALL WITH US")]
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }